import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import { routes } from "./index";

import Navbar from "../components/Common/Nav/Navbar";
import Footer from "../components/Common/Nav/Footer";
import CookieBanner from "../components/Common/CookieBanner";
import OfflineBanner from "../components/Common/OfflineBanner";
import Api from "../lib/componentApi";

const renderMergedProps = (component, title, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

//private route async çalışıyor
const PrivateRoute = ({ component, authed, ...rest }) => {
  // eslint-disable-next-line
  let auth = __isBrowser__ ? window.authed : authed;
  return (
    <Route
      {...rest}
      render={routeProps =>
        auth ? (
          renderMergedProps(component, rest.title, routeProps, rest)
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: routeProps.location }
            }}
          />
        )
      }
    />
  );
};

const PublicRoute = ({ component, authed, ...rest }) => {
  // eslint-disable-next-line
  let auth = __isBrowser__ ? window.authed : authed;
  return (
    <Route
      {...rest}
      render={routeProps => {
        return renderMergedProps(component, rest.name, routeProps, rest, {
          authed: auth
        });
      }}
    />
  );
};

const Layout = serverData => {
  // eslint-disable-next-line
  const authed = __isBrowser__ ? window.authed : serverData.authed;

  if (typeof authed !== "boolean") {
    return <div />;
  }

  return (
    <div>
      <Navbar authed={authed} />
      <div className="">
        <Switch>
          {routes.map(route =>
            route.private ? (
              <PrivateRoute
                key={`route-${route.name}`}
                {...route}
                authed={authed}
              />
            ) : (
              <PublicRoute
                key={`route-${route.name}`}
                {...route}
                authed={authed}
              />
            )
          )}
        </Switch>
      </div>
      <OfflineBanner />
      <CookieBanner />
      <Footer authed={authed} />
    </div>
  );
};

export default withRouter(Layout);
